export const colorGray = 'rgba(70,70,70,.55)';
export const colorRed = '#D32228';